import { render, staticRenderFns } from "./AnnualAddIndex.vue?vue&type=template&id=36a08985&"
import script from "./AnnualAddIndex.vue?vue&type=script&lang=js&"
export * from "./AnnualAddIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports